import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../../../constant/TYPE";
import Button from "../../../../../../../../common/Button";
import MoreA from "./MoreA";
import MoreB from "./MoreB";
import MoreC from "./MoreC";
import MoreD from "./MoreD";
import MoreE from "./MoreE";
import MoreF from "./MoreF";
import MoreG from "./MoreG";
import MoreH from "./MoreH";

const AlphabetKeyset = ( props ) => {

  const keypad = useSelector( state => state.keypad );

  return (
    <div className="tabCont active">
      <table className="key_tbl" summary="키패드">
        <tbody>
        <tr>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.A === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.A } latex="a" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_a.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.A === keypad.moreKeyName && <MoreA /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.B === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.B } latex="b" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_b.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.B === keypad.moreKeyName && <MoreB /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.C === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.C } latex="c" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_c.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.C === keypad.moreKeyName && <MoreC /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.D === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.D } latex="d" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_d.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.D === keypad.moreKeyName && <MoreD /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.E === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.E } latex="e" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_e.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.E === keypad.moreKeyName && <MoreE /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.F === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.F } latex="f" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_f.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.F === keypad.moreKeyName && <MoreF /> }
          </td>
        </tr>
        <tr>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.G === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.G } latex="g" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_g.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.G === keypad.moreKeyName && <MoreG /> }
          </td>
          <td className={ clsx( 'more', TYPE.KEYPAD_MORE.H === keypad.moreKeyName && 'open' ) }>
            <Button className="more_btn" name={ TYPE.KEYPAD_MORE.H } latex="h" onClick={ props.onKey } onTouchStart={ props.onTouchStart }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_h.svg` } alt="" /></Button>
            { TYPE.KEYPAD_MORE.H === keypad.moreKeyName && <MoreH /> }
          </td>
          <td><Button latex="i" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_i.svg` } alt="" /></Button></td>
          <td><Button latex="m" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_m.svg` } alt="" /></Button></td>
          <td><Button latex="n" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_n.svg` } alt="" /></Button></td>
          <td><Button latex="p" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_p.svg` } alt="" /></Button></td>
        </tr>
        <tr>
          <td><Button latex="r" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_r.svg` } alt="" /></Button></td>
          <td><Button latex="t" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_t.svg` } alt="" /></Button></td>
          <td><Button latex="x" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_x.svg` } alt="" /></Button></td>
          <td><Button latex="y" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_y.svg` } alt="" /></Button></td>
          <td><Button latex="z" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_z.svg` } alt="" /></Button></td>
          <td />
        </tr>
        <tr className="l_gray">
          <td><Button latex="(" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_open_parenthesis.svg` } alt="" /></Button></td>
          <td><Button latex=")" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_close_parenthesis.svg` } alt="" /></Button></td>
          <td><Button latex="-" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_subtract.svg` } alt="" /></Button></td>
          <td><Button latex="+" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_add.svg` } alt="" /></Button></td>
          <td><Button latex="=" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_equal.svg` } alt="" /></Button></td>
          <td className="d_gray"><Button latex={ TYPE.KEY_STROKE.BACKSPACE } onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_backspace.svg` } alt="" /></Button></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default AlphabetKeyset;
